import styles from "./OnlineIncrease.module.scss";
import NotificationError from "../../../../helpers/errors_notifications/NotificationError";
import { useState } from "react";
import { convertNumbers2English } from "../../../../utils/priceFunc";
import { errorMessage } from "../../../../utils/messages";
import { onlinePaymentIncrease } from "../../../../services/adminServices";
import ArrowIcon from "../../../../styles/icon/arrowdown.svg";
import Num2persian from "num2persian";
export default function OnlineIncrease({ cards }) {
  const textNotification =
    "مبالغ واریزی فقط برای خرید از سایت میباشد و امکان برداشت مبلغ بدون خرید ارز وجود ندارد.";
  //
  const [userCart, setUserCart] = useState("");
  const [price, setPrice] = useState("");
  const [cardsList, openCardsList] = useState("");
  const [disableBtn, setDisableBtn] = useState(false);
  const handleOnlinePayment = async (e) => {
    e.preventDefault();
    if (!userCart) return errorMessage("کارت مورد نظر را انتخاب کنید");
    if (price < 50000)
      return errorMessage("حداقل مقدار واریز 50,000 تومان است");
    setDisableBtn(true);
    try {
      const body = { cardNumber: userCart, amount: price };
      const data = await onlinePaymentIncrease(body);
      if (data.data.message === "ok") {
        window.location.href = data.data.url;
      } else {
        errorMessage(data.data.message);
      }
    } catch (ex) {
      errorMessage("خطایی رخ داده مجددا تلاش کنید");
    } finally {
      setDisableBtn(false);
    }
  };
  return (
    <div className={styles.container}>
      <div>
        <NotificationError
          bgColor="rgba(246, 85, 85, 0.05)"
          fontColor="rgba(246, 85, 85, 1)"
          bgBorder="rgba(246, 85, 85, 1)"
          text={textNotification}
        />
      </div>
      <form onSubmit={(e) => handleOnlinePayment(e)}>
        <div className={styles.inputs_container}>
          <p className="font_color_white">
            کارتی که قصد خرید با آن را دارید انتخاب کنید:
          </p>
          <div className={styles.cards_pick_container}>
            <label htmlFor="checkbox-online-increase">
              <input
                type="checkbox"
                className={styles.checkBox}
                id="checkbox-online-increase"
                onChange={(e) => openCardsList(e.target.checked)}
                value={cardsList}
              />
              <div
                className={`changeBackgroundToWhite changeFontColorToBlack ${styles.label}`}
              >
                <div>انتخاب کارت</div>
                <div>
                  <img
                    src={ArrowIcon}
                    alt=""
                    width={14}
                    height={14}
                    className="convertPicToGreen"
                  />
                </div>
              </div>
            </label>
            <ul
              className={`${styles.ul_cards} ${
                cardsList ? styles.openThis : ""
              }`}
            >
              {cards &&
                cards?.map((card) => (
                  <li key={card.cardNumber}>
                    <label>
                      <div
                        className={`changeBackgroundToWhite   ${styles.for_grid}`}
                      >
                        <input
                          type="radio"
                          style={{ display: "none" }}
                          name="CardsChoice"
                          value={card.cardNumber}
                          className={styles.radioCardChoice}
                          checked={userCart === card.cardNumber}
                          onChange={(e) => setUserCart(e.target.value)}
                        />
                        <div className={styles.checkBox2}></div>
                        <div
                          className={`changeFontColorToBlack ${styles.cardNum}`}
                        >
                          {card.cardNumber}
                        </div>
                      </div>
                    </label>
                  </li>
                ))}
            </ul>
          </div>
          <input
            className={`changeBackgroundToWhite changeFontColorToBlack ${styles.amount}`}
            type="number"
            placeholder="مبلغ واریز(تومان)"
            onChange={(e) => setPrice(convertNumbers2English(e.target.value))}
            value={price}
          />
          <div className={styles.persian_price}>
            {price ? Num2persian(convertNumbers2English(price)) + " تومان" : ""}
          </div>
          <button type="submit" disabled={disableBtn}>
            پرداخت
          </button>
        </div>
      </form>
    </div>
  );
}
